module.exports = __webpack_public_path__ + "d913683389839d245eb2d8bff2899d5a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img8.jpeg
// module id = 1334
// module chunks = 0